<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="emEquipmentchecks"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button v-if="addAuth" type="primary" @click="$refs.editEMEquipmentcheck.open(0)">新建</el-button>
        <el-upload
            :action="uploadUrl"
            :before-upload="beforeAvatarUpload"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin-right: 5px;margin-left: 20px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="primary">导入</el-button>
        </el-upload>
        <el-button icon="el-icon-download" type="primary" @click="downloadExcel()">下载导入模板</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="设备编号">
            <el-input v-model.trim="filter.equipmentNO" clearable/>
          </vm-search>
          <vm-search label="点检内容">
            <el-input v-model.trim="filter.checkContent" clearable/>
          </vm-search>
          <vm-search label="点检方法">
            <el-input v-model.trim="filter.checkWay" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="equipmentNO" align="center" label="设备编号" width="120"/>
      <el-table-column prop="checkContent" align="center" label="点检内容"/>
      <el-table-column prop="checkWay" align="center" label="点检方法"/>
      <el-table-column prop="checkOnDay" align="center" label="日点检" width="100"/>
      <el-table-column prop="checkOnWeek" align="center" label="周点检" width="100"/>
      <el-table-column prop="checkOnMonth" align="center" label="月点检" width="100"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="150px">
        <template slot-scope="scope">
          <el-button v-if="editAuth" type="info" @click="$refs.editEMEquipmentcheck.open(scope.row.pkid)">编辑</el-button>
          <el-button v-if="delAuth" type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <e-m-equipmentcheck-edit ref="editEMEquipmentcheck" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EMEquipmentcheckEdit from "@/views/em/EMEquipmentcheck/EMEquipmentcheckEdit";

  export default {
    name: "EMEquipmentcheckList",
    components: {EMEquipmentcheckEdit, VmTable,VmSearch},
    data() {
      return {
        addAuth: this.$auth(637),
        editAuth: this.$auth(638),
        delAuth: this.$auth(639),
        idList: "",
        exportLoading: false,
        importLoading: false,
        uploadUrl: window.config.basicServerHttpUrl + "emEquipmentchecks/importExcel",
        disabled: false,
        filter: {
          equipmentNO: "",
          checkContent: "",
          checkWay: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
      downloadExcel() {
        window.open("/publicFile/设备点检导入模板.xlsx");
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","emEquipmentchecks",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
